export interface IDownloadClauseExtesnion {
    id?: number;
    idList?: any[];
}

export class DownloadClauseExtesnion implements IDownloadClauseExtesnion {
    constructor(public id?: number, public idList? : any[] ) {}
}